import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {ConfiguratorPageComponent} from './pages/configurator-page/configurator-page.component';
import {SaveConfigurationPageComponent} from './pages/save-configuration-page/save-configuration-page.component';
import {ProfilePageComponent} from './pages/profile-page/profile-page.component';
import {ProjectDetailsPageComponent} from './pages/project-details-page/project-details-page.component';
import {PatternDetailsPage} from './pages/pattern-details/pattern-details.page';
import {InspirationPage} from './pages/inspiration/inspiration.page';
import {FabricsPage} from './pages/fabrics/fabrics.page';
import {FabricDetailsPage} from './pages/fabric-details/fabric-details.page';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
    },
    {
        path: 'configurator',
        component: ConfiguratorPageComponent
    },
    {
        path: 'configurator/:patternId',
        component: ConfiguratorPageComponent
    },
    {
        path: 'configuration/save',
        component: SaveConfigurationPageComponent
    },
    {
        path: 'configuration/edit/:projectId',
        component: ConfiguratorPageComponent
    },
    {
        path: 'profile',
        component: ProfilePageComponent
    },
    {
        path: 'details/:projectId',
        component: ProjectDetailsPageComponent
    },
    {
        path: 'pattern/:patternId',
        component: PatternDetailsPage
    },
    {
        path: 'inspiration/:inspirationId',
        component: InspirationPage
    },
    {
        path: 'fabrics',
        component: FabricsPage
    },
    {
        path: 'fabric/:fabricId',
        component: FabricDetailsPage
    },
    {
        path: 'tabs',
        loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
    },
    {
        path: 'patterns',
        loadChildren: () => import('./pages/patterns/patterns.module').then(m => m.PatternsPageModule)
    },
    {
        path: 'pattern-details',
        loadChildren: () => import('./pages/pattern-details/pattern-details.module').then(m => m.PatternDetailsPageModule)
    },
  {
    path: 'cookies',
    loadChildren: () => import('./pages/cookies/cookies.module').then( m => m.CookiesPageModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/privacy/privacy.module').then( m => m.PrivacyPageModule)
  },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
